<template>
  <div>
    <div id="donutchart">
      <apexchart
        ref="donutchart"
        type="donut"
        height="397"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    chartData: {
      type: Array,
      required: true,
    },
    chartLabels: {
      type: Array,
      required: true,
    },
    colors: {
      type: String,
      required: false,
    },
    border: {
      type: String,
      required: false,
    },
    tooltipColor: {
      type: String,
      required: false,
    },
    emoji: {
      type: String,
      required: false,
    },
    chartDataType: {
      type: String,
      required: false,
    },
    labelColor: {
      type: String,
      required: false,
    },
  },
  data: function () {
    return {
      series: this.chartData,
      chartOptions: {
        labels: this.chartLabels,
        colors: [
          "#FFA500",
          "#3464ED",
          "#00FFA5",
          "#FFDF40",
          "#FF225B",
          "#28FFD1",
          "#0FF36C",
          "#F30F24",
          "#7501A7",
          "#606f11",
          "#97ffe4",
          "#e908a1",
          "#41ff18",
          "#b74777",
          "#8375ce",
        ],
        chart: {
          type: "donut",
          height: 350,
        },
        dataLabels: {
          enabled: true,
        },
        legend: {
          show: true,
          position: "bottom",
          offsetY: 0,
          labels: {
            colors: [this.labelColor],
            useSeriesColors: false,
          },
        },
      },
    };
  },
  watch: {
    chartData: function () {
      this.series = this.chartData;
      this.$refs.donutchart.updateOptions({
        labels: this.chartLabels,
      });
    },
    labelColor: function () {
      this.$refs.donutchart.updateOptions({
        legend: {
          show: true,
          position: "bottom",
          offsetY: 0,
          labels: {
            colors: [this.labelColor],
            useSeriesColors: false,
          },
        },
      });
    },
  },
};
</script>